<template>
    <base-dialog ref="base">
        <v-card>
            <v-card-title>
                Закупка "{{purchase.title}}"
            </v-card-title>
            <v-card-subtitle>
                Перерасчет процента заказов закупки
            </v-card-subtitle>
            <v-card-text>
                <v-text-field hide-details :disabled="loading_recalculation" class="mt-1" dense outlined
                              label="Новый процент"
                              v-only-number
                              v-model.number="data.percent"></v-text-field>
            </v-card-text>
            <v-card-title>
                Параметры
            </v-card-title>
            <v-card-text>
                <v-switch class="mt-0" inset label="Обновить процент заказов у альбомов" v-model="data.need_update_orders"></v-switch>
                <v-switch class="mt-0" inset label="Не учитывать заказы с предоплатой поставщику" v-model="data.ignore_prepaid_orders"></v-switch>
                <div class="subtitle-2 mb-2">
                    Выбрать альбомы
                </div>
                <v-select hide-details dense outlined label="У которых" class="mb-2"
                          :items="type_items" v-model="data.album_type"></v-select>
                <v-container class="py-0" fluid>
                    <v-row>
                        <v-col class="py-0 pl-0 pr-1" cols="6">
                            <v-select hide-details dense outlined :disabled="data.album_type === null" label="Условие" :items="condition_items"
                                      v-model="data.album_condition"></v-select>
                        </v-col>
                        <v-col class="py-0 pr-0 pl-1" cols="6">
                            <v-text-field :disabled="data.album_condition === null" hide-details dense outlined
                                          label="Сумма"
                                          v-only-number.float
                                          v-model.number="data.album_value">
                                <template v-slot:append>
                                    <div style="font-size: 25px">₽</div>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container fluid class="py-0">
                    <v-row>
                        <v-col cols="12" class="pb-1 pt-2 text-right">
                            <v-btn :disabled="loading_recalculation" @click="$refs.base.hide()" class="btn btn-h mr-1">
                                Отмена
                            </v-btn>
                            <v-btn color="primary" :loading="loading_recalculation" @click="onRecalculationPercent"
                                   class="btn btn-h">Пересчитать
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </base-dialog>
</template>

<script>
    import BaseDialog from "../utils/BaseDialog";
    import EventBus from "../../event-bus";
    import {mapActions} from "vuex";

    export default {
        name: "RecalculationPercentDialog",
        components: {BaseDialog},
        data() {
            return {
                data: {
                    percent: 0,
                    album_condition: undefined,
                    album_value: undefined,
                    album_type: undefined,
                    need_update_orders: false,
                    ignore_prepaid_orders: false,
                },
                loading_recalculation: false,
                purchase: {},
                condition_items: [
                    {text: 'Нет', value: null},
                    {text: 'Больше', value: '>'},
                    {text: 'Меньше', value: '<'},
                    {text: 'Равно', value: '='},
                ],
                type_items: [
                    {text: 'Без исключений (все альбомы)', value: null},
                    {text: 'Сумма выкупа (без учёта %)', value: 'P'},
                    {text: 'Сумма всех заказов (без учёта %)', value: 'A'},
                ]
            }
        },
        methods: {
            ...mapActions('purchases', [
                'recalculationPercent'
            ]),
            onRecalculationPercent() {
                this.loading_recalculation = true;
                this.recalculationPercent(this.data)
                    .then(() => {
                        this.loading_recalculation = false;
                        this.$refs.base.hide()
                    })
                    .catch(() => {
                        this.loading_recalculation = false;
                    })
            }
        },
        created() {
            const vm = this;
            EventBus.$on('recalculation_percent_dialog', function (purchase) {
                if (vm.$refs.base !== undefined) {
                    vm.$refs.base.show();
                }
                vm.$set(vm, 'data', {
                    percent: 0,
                    album_condition: null,
                    album_value: '',
                    purchase: purchase.id,
                    album_type: null,
                    need_update_orders: false,
                })
                vm.$set(vm, 'purchase', purchase)
            })
        }
    }
</script>